// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Divider, Grid, TextField } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';

// CUSTOM
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import InputNumeric from '../../formFields/InputNumeric';
import DatePickerField from '../../formFields/datePickerField';
import HourPicker from '../../formFields/HourPicker';
import { useFormikContext } from 'formik';
import dayjs from 'dayjs';
import DatePickerEditField from '../../formFields/DatePickerEditField';
import EditHourPicker from '../../formFields/EditHourPicker';

// Usar plugin para AM/PM si aún no lo tienes
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

export const EditarNovedadTurno = (props: any) => {
  const formikProps: any = useFormikContext();

  const { tiponovedades_select } = useSelector((state: any) => state.tiponovedades);
  const { employee_select } = useSelector((state: any) => state.employee);

  const { novedades_turno } = useSelector((state: any) => state.novedadesTurno);

  const [employee_selected, setEmployeeSelected] = useState([]);
  const [responsble_selected, setResponsableSelected] = useState([]);

  const [defaultDateNt, setDefaultDateNt] = useState<any>(null);
  const [selectedTimeNt, setSelectedTimeNt] = useState<any>(null);

  const {
    formField: {
      e_colaborador,
      e_responsable,
      e_tipoNovedad,
      e_fechaNovedad,
      e_horaNovedad,
      e_description,
    },
  } = props;

  useEffect(() => {
    setData(novedades_turno);
  }, [novedades_turno]);

  const setData = (novedad_turno: any) => {
    const [hour, minute] = novedad_turno.hora_novedad.split(':');

    // ID COMPANY
    formikProps.setFieldValue('novedadTurnoId', novedad_turno.id);
    // DATOS BASICOS
    formikProps.setFieldValue('e_colaborador', {
      value: novedad_turno.empleado.id,
      label: novedad_turno.empleado.name,
    });
    formikProps.setFieldValue('e_responsable', {
      value: novedad_turno.responsable.id,
      label: novedad_turno.responsable.name,
    });
    formikProps.setFieldValue('e_tipoNovedad', {
      value: novedad_turno.tipoNovedad.id,
      label: novedad_turno.tipoNovedad.name,
    });
    formikProps.setFieldValue(
      'e_fechaNovedad',
      dayjs(novedad_turno.fecha_novedad).format('YYYY-MM-DD')
    );
    formikProps.setFieldValue(
      'e_horaNovedad',
      dayjs().hour(parseInt(hour)).minute(parseInt(minute)).format('hh:mm A')
    );
    formikProps.setFieldValue('e_description', novedad_turno.descripcion);

    setDefaultDateNt(new Date(novedad_turno.fecha_novedad));

    setSelectedTimeNt(dayjs(novedad_turno.hora_novedad, 'HH:mm:ss'));
  };

  const formatUserForSelect = (user: any) => {};

  useEffect(() => {
    setResponsableSelected(JSON.parse(JSON.stringify(employee_select)));
  }, [employee_select]);

  console.log('employee_selected ', employee_selected);

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  return (
    <div>
      <div>
        <Grid container>
          {/* ************ */}
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={employee_select}
              name={e_colaborador.name}
              label={e_colaborador.label}
              element={e_colaborador.name}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={responsble_selected}
              name={e_responsable.name}
              label={e_responsable.label}
              element={e_responsable.name}
            />
          </Grid>
          {/* ************ */}

          {/* ************ */}
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={tiponovedades_select}
              name={e_tipoNovedad.name}
              label={e_tipoNovedad.label}
              element={e_tipoNovedad.name}
            />
          </Grid>
          <Grid size={{ xs: 3 }} sx={{ padding: 2 }}>
            {defaultDateNt && (
              <DatePickerEditField
                label={e_fechaNovedad.label}
                name={e_fechaNovedad.name}
                defaultDate={defaultDateNt}
              />
            )}
          </Grid>
          <Grid size={{ xs: 3 }} sx={{ padding: 2 }}>
            {selectedTimeNt && (
              <EditHourPicker
                label={e_horaNovedad.label}
                name={e_horaNovedad.name}
                defaultHour={selectedTimeNt}
              />
            )}
          </Grid>
          {/* ************ */}

          {/* ************ */}
          <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            <TextAreaField
              name={e_description.name}
              label={e_description.label}
              variant="outlined"
              fullWidth
            />
          </Grid>
          {/* ************ */}

          <Divider />
        </Grid>
      </div>
    </div>
  );
};
